import { Sheet } from "@mui/joy";
import React from "react";

export default function CellContainer({
  readOnly,
  isCoachFieldEmpty,
  onAttemptEdit,
  children,
}: {
  readOnly?: boolean;
  isCoachFieldEmpty?: boolean;
  onAttemptEdit?: () => void;
  children: React.ReactNode;
}) {
  const handleOverlayClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    if (!onAttemptEdit) return;
    const overlay = e.currentTarget as HTMLElement;

    // Temporarily disable pointer events on the overlay to read the element
    // underneath the cursor. Otherwise `elementFromPoint` always returns the
    // overlay itself which prevents us from checking the actual target.
    const previousPointerEvents = overlay.style.pointerEvents;
    overlay.style.pointerEvents = "none";

    const el = document.elementFromPoint(
      e.clientX,
      e.clientY
    ) as HTMLElement | null;

    overlay.style.pointerEvents = previousPointerEvents;

    if (el?.closest('textarea, input, [contenteditable="true"], .ql-editor')) {
      onAttemptEdit();
    }
  };
  return (
    <Sheet
      sx={{
        backgroundColor: "transparent",
        position: "relative",
        width: "100%",
      }}
    >
      {isCoachFieldEmpty && (
        <Sheet
          className="w-[calc(100%+2px)] h-[calc(100%+2px)] top-[-1px] left-[-1px] pointer-events-none"
          sx={{
            backgroundColor: "transparent",
            position: "absolute",
            borderWidth: "var(--joy-focus-thickness, 2)",
            borderRadius: "6px",
            borderColor: "danger.outlinedColor",
            zIndex: 1,
          }}
        />
      )}
      {readOnly && onAttemptEdit && (
        <Sheet
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 2,
            backgroundColor: "transparent",
          }}
          onClick={handleOverlayClick}
        />
      )}
      {children}
    </Sheet>
  );
}
